import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { LevelService } from 'src/app/services/level.service';

@Component({
  selector: 'app-list-level',
  templateUrl: './list-level.component.html',
  styleUrls: ['./list-level.component.css']
})
export class ListLevelComponent implements OnInit {
  eventsSubject: Subject<any> = new Subject<any>();


  displayedColumns: string[] = ['name','rewardCode', 'rewardName', 'status', 'actions'];
  imageColumn = [ {field: 'photo', header: 'Logo'}]
  columnsToDisplay = [{field: 'name', header: 'Nome', type: 'text'}, {field: 'description', header: 'Descrição', type: 'text'},
  {field: 'rewardCode', header: 'Código do Prémio', type: 'text'}, {field: 'rewardName', header: 'Nome do Prémio', type: 'text'}];
  columnsObject = [{field: 'store', object:'store', subObject:'name', header: 'Loja', type: 'select', selectFieldsDados: []},];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados: [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: true, statusUpdate: true};
  title = 'Níveis';
  novo = {link: '/levels/criar', nome: 'Novo Nível'};
  page: any = {base: null, name: null};
  service;

  constructor(private storeService: StoreService,
    private route: ActivatedRoute,
    private levelService: LevelService,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.levelService.getAll;
this.storeService.getAll(null).pipe(first())
      .subscribe(
          data => {
            console.log('lojas', data);
            this.columnsObject[0].selectFieldsDados = data['content'];
          },
          error => {
            console.log('error', error);
        });
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.id } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.id } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.levelService.inactive(args.id);
      textConfirm = 'Pretende Desactivar o Nível ' + args.name + '? Ao desactivar o nível o estado do Nível será alterado para INATIVO.';
      status = 'INACTIVE';
      textShow = 'NÍVEL DESATIVADO COM SUCESSO';
    }
    else{
      service = this.levelService.active(args.id);
      textConfirm = 'Pretende Activar o Nível ' + args.name + '? Ao activar o Nível o estado do Nível será alterado para ATIVO';
      status = 'ACTIVE';
      textShow = 'NÍVEL ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar este Nível ' + args.name + '? Ao eliminar os dados do Nível serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.levelService.delete(args.id).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }

